export default __webpack_public_path__ + "static/media/pexels-hugo-butery-7272375.7123a6f3.mp4";